const LANDING_PATHS = new Set(['/']);

function parseConfig() {
  const enabled = process.env.REACT_APP_ENABLE_DOMAIN_SPLIT === 'true';
  const landingHosts = (process.env.REACT_APP_LANDING_HOST || '')
    .split(',')
    .map((host) => host.trim().toLowerCase())
    .filter(Boolean);
  const appHost = (process.env.REACT_APP_APP_HOST || '').trim().toLowerCase();

  return { enabled, landingHosts, appHost };
}

export function isDomainSplitEnabled() {
  const { enabled, landingHosts, appHost } = parseConfig();
  return enabled && landingHosts.length > 0 && Boolean(appHost);
}

export function isLandingHost(hostname = typeof window !== 'undefined' ? window.location.hostname : '') {
  const { landingHosts } = parseConfig();
  return landingHosts.includes(String(hostname).toLowerCase());
}

export function isAppHost(hostname = typeof window !== 'undefined' ? window.location.hostname : '') {
  const { appHost } = parseConfig();
  return String(hostname).toLowerCase() === appHost;
}

export function isLandingPath(pathname) {
  return LANDING_PATHS.has(pathname);
}

export function isReferralPath(pathname) {
  return pathname === '/referral' || pathname.startsWith('/referral/');
}

export function isLegalPath(pathname) {
  return pathname === '/terms' || pathname === '/privacy';
}

/** Development-only design lab. Never redirect it between hosts. */
export function isDesignLabPath(pathname) {
  return pathname === '/design-lab' || pathname.startsWith('/design-lab/');
}

/** Routes allowed on the landing host (marketing + public referral links). */
export function isLandingAllowedPath(pathname) {
  return isLandingPath(pathname) || isReferralPath(pathname) || isLegalPath(pathname);
}

function buildAbsoluteUrl(host, path = '/') {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const protocol =
    typeof window !== 'undefined' && window.location.protocol
      ? window.location.protocol
      : 'https:';
  return `${protocol}//${host}${normalizedPath}`;
}

export function landingUrl(path = '/') {
  const { landingHosts } = parseConfig();
  const host = landingHosts[0];
  if (!host) {
    return path;
  }
  return buildAbsoluteUrl(host, path);
}

export function appUrl(path = '/') {
  const { appHost } = parseConfig();
  if (!appHost) {
    return path;
  }
  return buildAbsoluteUrl(appHost, path);
}

export function redirectToApp(pathname, search = '', hash = '') {
  window.location.replace(appUrl(`${pathname}${search}${hash}`));
}

export function redirectToLanding(pathname, search = '', hash = '') {
  window.location.replace(landingUrl(`${pathname}${search}${hash}`));
}

export function navigateToAppPath(path) {
  if (isDomainSplitEnabled() && isLandingHost()) {
    window.location.href = appUrl(path);
    return true;
  }
  return false;
}

export function navigateToLandingPath(path) {
  if (isDomainSplitEnabled() && isAppHost()) {
    window.location.href = landingUrl(path);
    return true;
  }
  return false;
}
